import config from '@/const';

/**
 * 所有主题的基础，为了简化加一个新主题的工作，也为了减少所有主题的体积；
 * 使用方法，从 api 加载主题后 _.merge 到本基础主题后使用，注意：这里的 merge 不会特殊处理 type、extend 等
 * @date 2019-10-24
 *
 * 字段说明
 * norm：标记该数据块是否对应为页面的某个绘制区域，0为不绘制，其他Ture类型均表示绘制：
 *    用于value字段下时，表示元素的绘制与否
 *    否则，用于标记是否对应到component
 * norm：标记该数据块是否对应为页面的某个绘制区域，0为不绘制，其他Ture类型均表示绘制：
 */

const cssDirection = (attr, t = 0, r = 0, b = 0, l = 0) => ({
  [`${attr}Top`]: t,
  [`${attr}Right`]: r,
  [`${attr}Bottom`]: b,
  [`${attr}Left`]: l,
});

export const themeBase = () => ({
  name: '主题base数据',
  description: '所有主题的基础定义',
  scale: 100,
  // 额定页面大小
  size: [800, 450],
  'color-map': {
    // 0: 'linear-gradient(180deg,rgba(242,242,242,1) 0%,rgba(220,220,220,1) 100%)',
    // 1: 'linear-gradient(180deg,rgba(34,131,183,1) 0%,rgba(15,76,129,1) 100%)',
    categorical: [
      'rgb(31, 119, 180)',
      'rgb(255, 127, 14)',
      'rgb(44, 160, 44)',
      'rgb(214, 39, 40)',
      'rgb(148, 103, 189)',
      'rgb(140, 86, 75)',
      'rgb(227, 119, 194)',
      'rgb(127, 127, 127)',
      'rgb(188, 189, 34)',
      'rgb(23, 190, 207)',
    ],
    diverging: [
      'rgb(103, 0, 31)',
      'rgb(178, 24, 43)',
      'rgb(214, 96, 77)',
      'rgb(244, 165, 130)',
      'rgb(253, 219, 199)',
      'rgb(209, 229, 240)',
      'rgb(146, 197, 222)',
      'rgb(67, 147, 195)',
      'rgb(33, 102, 172)',
      'rgb(5, 48, 97)',
    ],
    sequential1: [
      'rgb(247, 251, 255)',
      'rgb(222, 235, 247)',
      'rgb(198, 219, 239)',
      'rgb(158, 202, 225)',
      'rgb(107, 174, 214)',
      'rgb(66, 146, 198)',
      'rgb(33, 113, 181)',
      'rgb(8, 81, 156)',
      'rgb(8, 48, 107)',
    ],
    sequential9: [
      'rgb(35, 23, 27)',
      'rgb(74, 88, 221)',
      'rgb(47, 157, 245)',
      'rgb(39, 215, 196)',
      'rgb(77, 248, 132)',
      'rgb(149, 251, 81)',
      'rgb(222, 221, 50)',
      'rgb(255, 164, 35)',
      'rgb(246, 95, 24)',
      'rgb(186, 34, 8)',
      'rgb(144, 12, 0)',
    ],
    sinebow: [
      'rgb(110, 64, 170)',
      'rgb(191, 60, 175)',
      'rgb(254, 75, 131)',
      'rgb(255, 120, 71)',
      'rgb(226, 183, 47)',
      'rgb(175, 240, 91)',
      'rgb(82, 246, 103)',
      'rgb(29, 223, 163)',
      'rgb(35, 171, 216)',
      'rgb(76, 110, 219)',
      'rgb(110, 64, 170)',
    ],
  },
  color: [
    ['rgb(51, 51, 51)', 'rgb(255, 255, 255)'],
    ['rgb(31, 119, 180)', 'rgb(255, 255, 255)'],
  ],
  page: {
    List: {
      style: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        backgroundColor: 'rgb(255, 255, 255)',
        // background: 'color-map.1',
      },
      extend: ['padding.page'],
    },
    // 首页
    Index: {
      style: {},
      // extend: ['page.List'],
    },
    Transition: {
      // extend: ['page.Index'],
    },
    Catalogue: {
      style: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        backgroundColor: 'rgb(255, 255, 255)',
        // background: 'color-map.1',
      },
      extend: ['padding.page'],
    },
  },
  // 页面元素：页眉
  header: {
    norm: 1,
    sort: 1,
    style: {
      marginTop: 0,
      marginBottom: 0,
      // 预留前置 ICON 的占用空间
      // paddingLeft: 40,
      display: 'grid',
      gridTemplateAreas: '"i h" "i l"',
      gridTemplateColumns: 'min-content auto',
      alignContent: 'end',
      alignItems: 'end',
      position: 'relative',
      gridArea: 'H',
      width: '100%',
    },
    extend: ['margin.normal'],
    // 示例-数据结构
    valueExample: {},
    value: {
      icon: {
        sort: 1,
        // 标识当前KEY-icon为标准KEY，避免绘制时显示了非当前value中定义的KEY
        norm: 1,
        value: '/image/tmp/header-logo.png',
        extend: ['image.1'],
        style: {
          marginRight: 6,
          gridArea: 'i',
          height: 30,
          width: 30,
        },
      },
      // 特殊意义字段：页标题
      header: {
        sort: 3,
        norm: 1,
        value: '',
        style: {
          gridArea: 'h',
          /*          marginBottom: -6,
          marginLeft: -6,*/
          width: '100%',
          display: 'flex',
          alignItems: 'flex-end',
        },
        attrs: {
          // placeholder: '添加本页标题',
        },
        extend: ['text.h1', 'padding.small'],
      },
      line: {
        sort: 3,
        norm: 1,
        value: '',
        style: {
          gridArea: 'l',
        },
        extend: ['line.1'],
      },
    },
  },
  // 页面元素：页脚
  footer: {
    norm: 0,
    sort: 1,
    style: {
      display: 'flex',
      flexGrow: '0',
      flexShrink: '0',
      flexBasis: '100%',
      marginBottom: 0,
      // opacity: '0',
      // pointerEvents: 'none',
      marginTop: 0,
      gridArea: 'F',
    },
    extend: ['margin.normal'],
    // 示例-数据结构
    valueExample: {},
    value: {
      date: {
        sort: 1,
        norm: 1,
        type: ['Template', 'Date'],
        value: '${YYYY}-${MM}-${DD}', // eslint-disable-line no-template-curly-in-string
        style: {},
        extend: ['footer.text'],
      },
      // 特殊意义字段：主体名称（或公司名、项目名）
      description: {
        sort: 2,
        norm: 1,
        value: `© 2019-2020 ${config.productName} copyright`,
        style: {
          flexGrow: '1',
          flexShrink: '1',
        },
        extend: ['footer.text'],
      },
      // 特殊意义字段：页码
      pageNumber: {
        sort: 3,
        norm: 1,
        type: ['Template', 'Page'],
        value: '${pageNumber}/${pageCount}', // eslint-disable-line no-template-curly-in-string
        style: {},
        extend: ['footer.text'],
      },
    },
    // 单元共用：文本
    text: {
      extend: ['padding.small', 'text.small'],
      attrs: {
        // placeholder: '-',
      },
      style: {
        color: 'color.0.0',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        flexGrow: '0',
        flexShrink: '0',
        flexBasis: 'auto',
      },
    },
  },
  // 页面元素：段落文本
  describe: {
    norm: 0,
    sort: 4,
    style: {
      flexBasis: '100%',
      gridArea: 'D',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative',
      justifyContent: 'center',
    },
    extend: ['padding.normal'],
    // 单元共用：文本
    text: {
      style: {
        flexBasis: '100%',
        textAlign: 'left',
        justifyContent: 'center',
      },
      extend: ['padding.small', 'text.normal'],
      attrs: {
        // placeholder: '添加附加文本',
      },
      settings: {
        _Title: '附加文本样式',
      },
    },
    // 示例-数据结构
    valueExample: {},
    value: {
      // 特殊意义字段：文本
      text: {
        sort: 1,
        norm: 1,
        extend: ['describe.text'],
        value: '',
      },
    },
    // 方位属性
    'body-top': {
      extend: ['describe'],
      style: {
        marginBottom: 0,
      },
    },
    // 方位属性
    'body-bottom': {
      extend: ['describe'],
      style: {
        marginTop: 0,
      },
    },
  },
  // 页面元素：插图
  plate: {
    norm: 0,
    sort: 2,
    style: {
      // overflow: 'hidden',
      gridArea: 'P',
      display: 'grid',
      gridGap: 10,
      gridTemplateAreas: "'a b ' 'a b'",
    },
    defaultTemplateAreas: [
      "'a'",
      "'a b''a b'",
      "'a b c'",
      "'a b''c d'",
      "'a a b''c d e'",
      "'a b c''d e f'",
    ],
    extend: ['padding.normal'],
    // 单元共用：图片
    image: {
      style: {
        zIndex: 0, // 否则选不中
        height: '100%',
        width: '100%',
      },
      settings: {
        editable: {
          search: false,
          upload: {
            title: '上传图片',
          },
        },
      },
      type: ['Plate'],
      extend: ['image.1'],
      attrs: {},
    },
    // 示例-数据结构
    valueExample: {},
    value: {},
    valueModel: {
      style: {
        position: 'relative',
        // overflow: 'hidden',
      },
      value: {
        image: {
          norm: 1,
          extend: ['plate.image'],
          style: {
            objectFit: 'cover',
          },
        },
        title: {
          norm: 1,
          extend: ['text.h2'],
          attrs: {},
        },
      },
    },
    grid: {
      style: {
        height: '100%',
        width: '100%',
      },
    },
    valueIndex: [],
    valueLength: [],
  },
  // 类似plate，但是面向未来的数据结构及解析器
  illustration: {
    norm: 0,
    sort: 3,
    style: {
      // overflow: 'hidden',
      gridArea: 'P',
    },
    extend: ['padding.normal'],
    // 单元共用：图片
    image: {
      style: {
        height: '100%',
        width: '100%',
      },
      settings: {
        editable: {
          search: {
            title: '高清图库',
          },
          upload: false,
        },
      },
      type: ['Illustration'],
      extend: ['image.1'],
      attrs: {},
    },
    // 示例-数据结构
    valueExample: {},
    value: {
      // 特殊意义字段：大图
      image: {
        sort: 1,
        norm: 1,
        extend: ['illustration.image'],
        // value: '/image/tmp/rp-bg-index-zip.jpeg',
        value: 'https://pub.jianzeppt.cn/image/islide/241418.jpg',

        style: {},
      },
    },
  },
  // 页面元素：主体内容
  // 该字段对应 template 中的 component 属性
  // 列表
  List: {
    norm: 0,
    sort: 5,
    style: {
      flexGrow: '1',
      flexShrink: '1',
      flexBasis: 'auto',
      display: 'flex',
      gridArea: 'L',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      flexWrap: 'wrap',
    },
  },
  // 首页
  Index: {
    norm: 1,
    sort: 4,
  },
  // 主题共用：图片
  image: {
    0: {
      type: ['Image'],
      settings: {
        // 支持编辑图片：更换、属性修改等
        editable: {
          // 搜索面板
          search: {
            // 面板标题
            title: '高清图库',
          },
          // 上传面板
          // upload: {
          // 面板标题
          // title: '上传图片',
          // },
        },
      },
    },
    1: {
      style: {},
      extend: ['image.0'],
    },
    onlyread: {
      extend: ['image.0'],
      settings: {
        editable: false,
      },
    },
  },
  // 主题共用：图标
  icon: {
    0: {
      type: ['Icon'],
      // fill
      // value: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">  <desc>Made with illustrio</desc>  <g class="base">    <g fill="currentColor" fill-rule="evenodd" stroke="none" class="main-fill"></g>    <g fill="currentColor" transform="translate(19 20)" stroke="none" class="main-fill">      <path        d="M17.9 23L15.2 23C14.8 23 14.5 23.2 14.5 23.5 14.5 24 14.8 24 15.2 24L17.9 24C18.3 24 18.5 24 18.5 23.5 18.5 23.2 18.2 23 17.9 23L17.9 23zM16.3 26.1C16.1 25.9 15.6 25.9 15.4 26.1 15.2 26.2 15.2 26.5 15.2 26.6 15.2 26.7 15.3 26.9 15.4 27.1 15.5 27.2 15.6 27.3 15.8 27.3 15.9 27.3 16.2 27.2 16.3 27.1 16.5 26.8 16.5 26.7 16.5 26.6 16.5 26.5 16.5 26.2 16.3 26.1L16.3 26.1zM17.7 19.7C18 19.5 18 19 17.7 18.8 17.4 18.6 17 18.6 16.7 18.8 16.6 18.9 16.2 19.3 15.9 19.3 15.5 19.3 15.2 18.9 15.1 18.8 14.8 18.6 14.4 18.6 14.1 18.8 13.8 19 13.8 19.5 14.1 19.7 14.2 19.9 14.9 20.7 15.9 20.7 16.9 20.7 17.6 20 17.7 19.7L17.7 19.7z"        fill="currentColor"        stroke="none"        class="main-fill"/>      <path        d="M26,5.3 L26,2.4 C26,2.4 25.9,2.4 25.9,2.3 L25.9,2.3 C26,2 25.8,1.6 25.4,1.5 C16.7,-0.6 8,1.4 7.6,1.5 C7.3,1.6 7,1.8 7.2,2.3 L7.1,2.3 L7,2.4 L7,5.3 L6.9,5.3 C2.6,6.4 0.4,8 0.4,9.7 C0.4,11.2 1.8,12.3 4,13 L4,13.8 C4,15.8 4.4,17 5.2,17.3 C5.5,17.4 5.6,17.3 5.8,17.3 C6.2,20.6 8.3,25.9 11.5,27.7 C12.8,29.1 13.7,28.9 14.8,28.9 L16.7,28.9 C18,28.9 18.8,28.7 19.9,27.7 C23.1,25.9 25.2,20.9 25.6,17.4 C25.8,17.4 26,17.4 26.3,17.3 C27.2,16.8 27.6,15.6 27.6,13.2 L27.6,13.2 C30.1,12.4 31.8,11.3 31.8,9.7 C31.6,8.5 31,6.6 26,5.3 L26,5.3 Z M23.3,2.4 C21.6,3 19.1,3.7 16.6,3.7 C14,3.7 11.3,3 9.7,2.4 C12.3,2.1 17.7,1.5 23.3,2.4 L23.3,2.4 Z M25.5,16.1 L25.2,16.1 L25.2,16.1 C25,16 24.8,16 24.5,16.1 C24.3,16.2 24.1,16.5 24.1,16.7 C24.1,19.6 21.9,25.3 19.1,26.8 C19.1,26.8 19,26.8 19,26.9 C18,28 17.6,28 16.7,28 L14.8,28 C13.8,28 13.4,28 12.3,26.8 C12.3,26.8 12.2,26.8 12.2,26.7 C9.2,25.3 7,19.2 7,16.5 C7,16.1 6.9,15.9 6.6,15.9 C6.4,15.8 6.1,15.9 5.9,16 C5.8,16 5.7,16.1 5.7,16.1 C5.7,16.1 5.3,15.9 5.3,13.9 L5.3,13.5 C6.2,13.8 7.3,14 8.4,14.1 C8.5,16.7 9.9,18.2 12.3,18.2 C14.3,18.2 15.6,17.1 16,15.3 C16.4,17.1 17.7,18.2 19.7,18.2 C22.1,18.2 23.5,16.7 23.6,14.1 C24.5,14 25.4,13.8 26.2,13.6 C26.1,15.8 25.6,16.1 25.5,16.1 L25.5,16.1 Z M21.3,13 L16.5,13 C16.3,13 16.2,13.1 16.1,13.2 L15.9,13.2 L15.9,13.2 C15.8,13.1 15.6,13 15.5,13 L10.6,13 C5,12.5 1.7,11.1 1.7,9.7 C1.7,8.9 3,7.6 7,6.7 L7,7.9 C7,8 7.1,8.1 7.2,8.2 C7.3,8.3 9.5,10.9 16.6,10.9 C23.7,10.9 25.6,8.5 25.8,8.2 C25.9,8.1 26,8 26,7.9 L26,6.7 C29,7.4 30.3,8.6 30.3,9.7 C30.3,11.1 27,12.5 21.3,13 L21.3,13 Z"        fill="currentColor"        stroke="none"        class="main-fill"/>    </g>  </g></svg>',
      // stroke
      value:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="8 8 54 54"><g><g fill="currentColor" fill-rule="evenodd" stroke="none"> </g><g fill="currentColor" stroke="none" transform="translate(20.364 17.818)"> <path d="M18.4545455 28L10.8181818 28C10.4669091 28 10.1818182 28.2844545 10.1818182 28.6363636 10.1818182 28.9882727 10.4669091 29.2727273 10.8181818 29.2727273L18.4545455 29.2727273C18.8064545 29.2727273 19.0909091 28.9882727 19.0909091 28.6363636 19.0909091 28.2844545 18.8064545 28 18.4545455 28L18.4545455 28zM18.4545455 30.5454545L10.8181818 30.5454545C10.4669091 30.5454545 10.1818182 30.8299091 10.1818182 31.1818182 10.1818182 31.5337273 10.4669091 31.8181818 10.8181818 31.8181818L18.4545455 31.8181818C18.8064545 31.8181818 19.0909091 31.5337273 19.0909091 31.1818182 19.0909091 30.8299091 18.8064545 30.5454545 18.4545455 30.5454545L18.4545455 30.5454545zM17.1818182 33.0909091L12.0909091 33.0909091C11.7396364 33.0909091 11.4545455 33.3753636 11.4545455 33.7272727 11.4545455 34.0791818 11.7396364 34.3636364 12.0909091 34.3636364L17.1818182 34.3636364C17.5337273 34.3636364 17.8181818 34.0791818 17.8181818 33.7272727 17.8181818 33.3753636 17.5337273 33.0909091 17.1818182 33.0909091L17.1818182 33.0909091zM14.6363636 5.09090909C9.373 5.09090909 5.09090909 9.373 5.09090909 14.6363636 5.09090909 18.1573636 7.07636364 21.4238182 10.1818182 23.0688182L10.1818182 26.0909091C10.1818182 26.4428182 10.4669091 26.7272727 10.8181818 26.7272727L18.4545455 26.7272727C18.8064545 26.7272727 19.0909091 26.4428182 19.0909091 26.0909091L19.0909091 23.0688182C22.197 21.4244545 24.1818182 18.158 24.1818182 14.6363636 24.1818182 9.373 19.8997273 5.09090909 14.6363636 5.09090909L14.6363636 5.09090909zM21 15.2727273C20.6480909 15.2727273 20.3636364 14.9876364 20.3636364 14.6363636 20.3636364 11.4787273 17.7946364 8.90909091 14.6363636 8.90909091 14.2850909 8.90909091 14 8.624 14 8.27272727 14 7.92145455 14.2850909 7.63636364 14.6363636 7.63636364 18.4959091 7.63636364 21.6363636 10.7768182 21.6363636 14.6363636 21.6363636 14.9876364 21.3519091 15.2727273 21 15.2727273L21 15.2727273zM3.18181818 14L.636363636 14C.285090909 14 0 14.2850909 0 14.6363636 0 14.9876364.285090909 15.2727273.636363636 15.2727273L3.18181818 15.2727273C3.53309091 15.2727273 3.81818182 14.9876364 3.81818182 14.6363636 3.81818182 14.2850909 3.53309091 14 3.18181818 14L3.18181818 14zM28.6363636 14L26.0909091 14C25.739 14 25.4545455 14.2850909 25.4545455 14.6363636 25.4545455 14.9876364 25.739 15.2727273 26.0909091 15.2727273L28.6363636 15.2727273C28.9882727 15.2727273 29.2727273 14.9876364 29.2727273 14.6363636 29.2727273 14.2850909 28.9882727 14 28.6363636 14L28.6363636 14zM14.6363636 3.81818182C14.9876364 3.81818182 15.2727273 3.53309091 15.2727273 3.18181818L15.2727273.636363636C15.2727273.285090909 14.9876364 0 14.6363636 0 14.2850909 0 14 .285090909 14 .636363636L14 3.18181818C14 3.53309091 14.2850909 3.81818182 14.6363636 3.81818182L14.6363636 3.81818182zM6.08681818 6.98663636C6.21090909 7.11072727 6.37381818 7.17309091 6.53672727 7.17309091 6.69963636 7.17309091 6.86254545 7.11072727 6.98663636 6.98663636 7.23545455 6.73781818 7.23545455 6.33563636 6.98663636 6.08681818L5.187 4.28718182C4.93818182 4.03836364 4.536 4.03836364 4.28718182 4.28718182 4.03836364 4.536 4.03836364 4.93818182 4.28718182 5.187L6.08681818 6.98663636 6.08681818 6.98663636zM23.1859091 22.2860909C22.9370909 22.0372727 22.5349091 22.0372727 22.2860909 22.2860909 22.0372727 22.5349091 22.0372727 22.9370909 22.2860909 23.1859091L24.0863636 24.9861818C24.2104545 25.1102727 24.3733636 25.1726364 24.5362727 25.1726364 24.6991818 25.1726364 24.8620909 25.1102727 24.9861818 24.9861818 25.235 24.7373636 25.235 24.3351818 24.9861818 24.0863636L23.1859091 22.2860909 23.1859091 22.2860909zM24.0863636 4.28718182L22.2860909 6.08681818C22.0372727 6.335 22.0372727 6.73781818 22.2860909 6.98663636 22.4101818 7.11072727 22.5730909 7.17309091 22.736 7.17309091 22.8989091 7.17309091 23.0618182 7.11072727 23.1859091 6.98663636L24.9861818 5.187C25.235 4.93881818 25.235 4.536 24.9861818 4.28718182 24.7373636 4.03836364 24.3345455 4.03836364 24.0863636 4.28718182L24.0863636 4.28718182zM6.08681818 22.2860909L4.28718182 24.0863636C4.03836364 24.3351818 4.03836364 24.7373636 4.28718182 24.9861818 4.41127273 25.1102727 4.57418182 25.1726364 4.73709091 25.1726364 4.9 25.1726364 5.06290909 25.1102727 5.187 24.9861818L6.98663636 23.1859091C7.23545455 22.9370909 7.23545455 22.5349091 6.98663636 22.2860909 6.73781818 22.0372727 6.335 22.0372727 6.08681818 22.2860909L6.08681818 22.2860909z" fill="currentColor" stroke="none" /> </g></g></svg>',
      settings: {
        // 支持编辑图标：更换、属性修改等
        editable: {
          // 搜索面板
          search: {
            // 面板标题
            title: '搜索图标',
          },
          // 上传面板
          upload: false,
        },
      },
      // 图标的类别，目前仅支持: fill、stroke
      category: 'fill',
    },
    1: {
      style: {},
      extend: ['icon.0'],
    },
    onlyread: {
      extend: ['icon.0'],
      settings: {
        editable: false,
      },
    },
  },
  // 主题共用：图形
  shape: {
    0: { type: ['Shape'] },
    1: {
      style: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'color.1.0',
        backgroundColor: 'color.1.1',
        boxShadow: 'none',
      },
      extend: ['shape.0'],
    },
    2: {
      style: {
        borderColor: 'color.2.0',
        backgroundColor: 'color.2.1',
      },
      extend: ['shape.1'],
    },
    'bgc-0': {
      style: {
        backgroundColor: 'none',
      },
      extend: ['shape.1'],
    },
    'bgc-1': {
      style: {
        borderColor: 'color.1.1',
        backgroundColor: 'color.1.0',
      },
      extend: ['shape.1'],
    },
  },
  // 主题共用：线条
  line: {
    0: {
      type: ['Line'],
    },
    1: {
      style: {
        backgroundColor: 'color.1.0',
        height: 1,
        boxShadow: 'none',
      },
      extend: ['line.0'],
    },
  },
  // 主题共用：文本
  text: {
    0: {
      style: {
        // boxSizing: 'content-box',
        wordBreak: 'break-all',
        fontFamily: '微软雅黑',
        color: 'color.0.0',
      },
      type: ['Text'],
      attrs: {
        // placeholder: '添加文本',
      },
      settings: {
        // 右侧属性面板的名称
        _Title: '文本样式',
        fontWeight: 1,
        fontStyle: 1,
        fontSize: 1,
        // 以列表的样式(ul、li)显示文本（统一变化）
        formatUniteList: 0,
      },
      operations: {
        // 需要统一变化的样式，这时，所设定的样式不是加给选中的文本，而是加给当前编辑器所有的文本
        uniteFormats: [],
        // 用于列表List中，所有item统一添加该样式，并且应用范围与 uniteFormats 相同，即整体文本添加样式
        listFormats: [],
      },
    },
    h1: {
      style: {
        fontSize: 32,
        fontWeight: 'bold',
      },
      extend: ['text.0'],
      type: ['Header', '1'],
      settings: {
        // 右侧属性面板的名称
        _Title: '标题样式',
      },
      attrs: {
        // placeholder: '添加标题',
      },
    },
    h2: {
      style: {
        fontSize: 18,
        fontWeight: 'bold',
      },
      extend: ['text.0'],
      type: ['Header', '2'],
      settings: {
        // 右侧属性面板的名称
        _Title: '小标题样式',
      },
      attrs: {
        // placeholder: '添加副标题',
      },
    },
    h3: {
      style: {
        fontSize: 15,
        fontWeight: 'bold',
      },
      extend: ['text.0'],
      type: ['Header', '3'],
      settings: {
        // 右侧属性面板的名称
        _Title: '小标题样式',
      },
      attrs: {
        // placeholder: '添加小标题',
      },
    },
    normal: {
      style: {
        fontSize: 12,
      },
      extend: ['text.0'],
      settings: {
        formatUniteList: 1,
        _Title: '文本样式',
      },
      attrs: {
        // placeholder: '添加文本',
      },
    },
    small: {
      style: {
        fontSize: 10,
      },
      extend: ['text.0'],
    },
    'flex-center': {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
  // 主题共用：图表
  charts: {
    norm: 0,
    sort: 2,
    style: {
      // overflow: 'hidden',
      // gridArea: 'E',
      display: 'grid',
      gridGap: 10,
      // gridTemplateAreas: "'a b ' 'a b'",
    },

    // defaultTemplateAreas: [
    //   "'a'",
    //   "'a'",
    //   "'a b''a b'",
    //   "'a b c'",
    //   "'a b''c d'",
    //   "'a a b''c d e'",
    //   "'a b c''d e f'",
    // ],
    // extend: ['padding.normal'],
    // 示例-数据结构
    valueExample: {},
    value: {},
    valueModel: {
      style: {
        // position: 'relative',
        // overflow: 'hidden',
      },
      type: ['Charts'],
      value: {
        charts: {
          norm: 1,
          extend: ['charts'],
          attrs: {},
          type: ['Charts'],
        },
        header: {
          norm: 0,
          extend: ['text.h1'],
          attrs: {},
        },
        description: {
          norm: 0,
          extend: ['text.h3'],
          attrs: {},
        },
      },
    },
    grid: {
      style: {
        height: '100%',
        width: '100%',
      },
    },
    valueIndex: [],
    valueLength: [],
  },
  // 主题绑定的默认页
  pages: {
    List: { templateId: 0 },
    Index: { templateId: 0 },
  },
});
